import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";
import {IBank} from "../../../../../../../utils/interfaces/my_documents/IBank";


const useApiCreateBank = (): UseMutationResult<IBank, CustomAxiosError, any> => {
    const {selectedCompany} = useAuth()
    const queryClient = useQueryClient();

    const {post} = useApiCalls()

    async function doCreate({companyToken, data}: {
        companyToken?: string,
        data: any
    }): Promise<IBank> {
        try {
            const response = await post(`/api/company/${companyToken}/my_documents/bank/`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    return useMutation<IBank, CustomAxiosError, any>(
        {
            mutationFn: (
                data
            ) => {
                return doCreate({
                    companyToken: selectedCompany?.company_token,
                    data
                })
            },
            onSuccess: async (obj) => {
                await queryClient.invalidateQueries({queryKey: ["useApiGetBanks"]});
            },
        }
    );
};


export default useApiCreateBank;